import React from "react";
import img1 from "./gallery/img1.jpg";
import img2 from "./gallery/img2.jpg";
import img4 from "./gallery/img4.jpg";
import img5 from "./gallery/img5.jpg";
import img6 from "./gallery/img6.jpg";
import img7 from "./gallery/img7.jpg";
import img8 from "./gallery/img8.jpg";
import img9 from "./gallery/img9.jpg";
import img10 from "./gallery/img10.jpg";
import img11 from "./gallery/img11.jpg";
import img12 from "./gallery/img12.jpg";
import img13 from "./gallery/img13.jpg";
import img14 from "./gallery/img14.jpg";
import img15 from "./gallery/img15.jpg";
import img16 from "./gallery/img16.jpg";




const students = [
  {
    id: 1,
    name: "Shivam",
    photo: img1,
    courseName: "ADCA",
    year: "2024",
    percentage: 95,
    passOutDate: "May 2024"
  },
  {
    id: 2,
    name: "Mohan",
    photo: img2,
    courseName: "DFA",
    year: "2024",
    percentage: 88,
    passOutDate: "June 2024"
  },
  
  {
    id: 4,
    name: "Mahima",
    photo: img4,
    courseName: "DFA",
    year: "2025",
    percentage: 90,
    passOutDate: "April 2025"
  },
  {
    id: 5,
    name: "Krishna",
    photo: img5,
    courseName: "ADCA",
    year: "2025",
    percentage: 96,
    passOutDate: "May 2025"
  },
  {
    id: 6,
    name: "Rohan",
    photo: img6,
    courseName: "DFA",
    year: "2024",
    percentage: 98,
    passOutDate: "July 2024"
  },
  {
    id: 7,
    name: "Priya",
    photo: img7,
    courseName: "ADCA",
    year: "2025",
    percentage: 94,
    passOutDate: "August 2025"
  },
  {
    id: 8,
    name: "Ankit",
    photo: img8,
    courseName: "DFA",
    year: "2024",
    percentage: 91,
    passOutDate: "September 2024"
  },
  {
    id: 9,
    name: "Sneha",
    photo: img9,
    courseName: "ADCA",
    year: "2025",
    percentage: 89,
    passOutDate: "October 2025"
  },
  {
    id: 10,
    name: "Aakash",
    photo: img10,
    courseName: "DTP",
    year: "2026",
    percentage: 93,
    passOutDate: "January 2026"
  },
  {
    id: 11,
    name: "Pooja",
    photo: img11,
    courseName: "Web",
    year: "2026",
    percentage: 97,
    passOutDate: "February 2026"
  },
  {
    id: 12,
    name: "Divya",
    photo: img12,
    courseName: "Programming",
    year: "2025",
    percentage: 95,
    passOutDate: "March 2025"
  },
  {
    id: 13,
    name: "Rahul",
    photo: img13,
    courseName: "ADCA",
    year: "2024",
    percentage: 90,
    passOutDate: "November 2024"
  },
  {
    id: 14,
    name: "Nisha",
    photo: img14,
    courseName: "DFA",
    year: "2026",
    percentage: 92,
    passOutDate: "April 2026"
  },
  {
    id: 15,
    name: "Sameer",
    photo: img15,
    courseName: "Web",
    year: "2025",
    percentage: 96,
    passOutDate: "May 2025"
  },
  {
    id: 16,
    name: "Aarti",
    photo: img16,
    courseName: "Tally",
    year: "2024",
    percentage: 94,
    passOutDate: "June 2024"
  },
 
];

export default function SuccessGallery() {
  return (
    <div style={{ padding: "20px", backgroundColor: "#f4f4f4", minHeight: "100vh" }}>
      <h1 style={{ textAlign: "center", color: "#333", marginBottom: "40px" }}>Success Gallery</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
        {students.map(student => (
          <div key={student.id} style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            padding: "20px",
            textAlign: "center"
          }}>
            <div style={{
              width: "270px",
              height: "400px",
              margin: "0 auto 15px",
              borderRadius: "10px"
            }}>
              <img src={student.photo} alt={student.name} style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px"
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}